import React from 'react'
import {Route,Routes,BrowserRouter, useNavigate} from "react-router-dom"
import Login from "./Pages/LoginPage/index"
import Home from "./Pages/HomePage/index"
import RestaurantPage from "./Pages/RestaurantDetails/index"
import UnAuthorizedRiders from "./Pages/UnAuthorizedRider/Index"
import UnAuthorizedChefs from "./Pages/UnAuthorizedChef/Index"
import Userdetails from "./Pages/UserDetails/index"
import WeekMealNotAdded from "./Pages/WeekMealNotAdded/index"
import EditContainer from "./Pages/EditContainer/Index"
import AddCoupon from "./Pages/Addcoupon/Index"
import CreateOnetimeorder from "./Pages/CreateOneTimeOrder/Index"
import CreateSubscription from "./Pages/CreateSubscription/Index"
import RatingsPage from "./Pages/RatingsPage/Index"
import Customdashboard from "./Pages/Customdashboard/index"
import BulkOrders from "./Pages/Bulk-Orders/Index"
import BulkWhatsAppMessages from "./Pages/Bulk-WhatsApp-Messages/Index"
import BulkWhatsAppMessageLogs from "./Pages/Bulk-WhatsApp-Message-Logs/Index"
import Batches from "./Pages/Batches/Index.jsx"
import RefundRequests from "./Pages/RefundRequests/Index"
import DelayedOrders from "./Pages/DelayedOrders/Index"
import Layout from "./components/Layout/Index"
import RestaurantDeliveryZones from "./Pages/RestaurantDeliveryZones/index"

const App = () => {
 
  return (
       <BrowserRouter>
<Routes>
  <Route path='/login' element={<Login/>}/>
  
  <Route element={<Layout />}>
    <Route path='/' element={<Home/>}/>
    <Route path='/restaurant/:id' element={<RestaurantPage/>}/>
    <Route path='/restaurant/:id/delivery-zones' element={<RestaurantDeliveryZones/>}/>
    <Route path='/unAuthorizedRiders' element={<UnAuthorizedRiders/>}/>
    <Route path='/unAuthorizedChefs' element={<UnAuthorizedChefs/>}/>
    <Route path='/:types' element={<Home/>} />
    <Route path="/userDetails/:number" element={<Userdetails />}/>
    <Route path='/weekmealnotadded' element={<WeekMealNotAdded />} />
    <Route path='/editContainer' element={<EditContainer />} />
    <Route path='/addCoupon' element={<AddCoupon />} />
    <Route path="/ratings/orders" element={<RatingsPage />} />
    <Route path="/onetimeorder/create" element={<CreateOnetimeorder/>} />
    <Route path="/subscription/create" element={<CreateSubscription/>} />
    <Route path="/Customdashboard" element={<Customdashboard/>} />
    <Route path="/bulk-orders" element={<BulkOrders/>} />
    <Route path="/bulk-whatsapp-messages" element={<BulkWhatsAppMessages/>} />
    <Route path="/bulk-whatsapp-message-logs" element={<BulkWhatsAppMessageLogs/>} />
    <Route path="/batches" element={<Batches/>} />
    <Route path="/delayed-orders" element={<DelayedOrders />} />
    <Route path="/refund-requests" element={<RefundRequests />} />
  </Route>
</Routes>
</BrowserRouter>
  )
}

export default App